import React from "react";
import "./Terms_conditions_modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

var HtmlToReactParser = require("html-to-react").Parser;
var htmlToReactParser = new HtmlToReactParser();

const Terms_conditions_modal = (props) => {
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="terms_and_condition_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Terms And Conditions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <ul>{props?.DashboardData?.name}</ul> */}

          <ul>{htmlToReactParser.parse(props?.DashboardData?.name)}</ul>
          {/* <ul>
            <li>
              By using our service center, you agree to comply with all
              applicable laws and regulations.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account information and password.
            </li>
            <li>
              We reserve the right to modify or terminate our services at any
              time without prior notice.
            </li>
            <li>
              All services provided are subject to availability and may be
              changed without notice.
            </li>
            <li>
              We are not liable for any damages or losses resulting from the use
              of our service center.
            </li>
            <li>
              Any personal data collected will be handled in accordance with our
              privacy policy.
            </li>
            <li>
              By using our service center, you consent to the collection and use
              of your data as described in our privacy policy.
            </li>
            <li>
              We reserve the right to update these terms and conditions at any
              time. Continued use of the service constitutes acceptance of the
              updated terms.
            </li>
          </ul>
          <ul>
            <li>
              By using our service center, you agree to comply with all
              applicable laws and regulations.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account information and password.
            </li>
            <li>
              We reserve the right to modify or terminate our services at any
              time without prior notice.
            </li>
            <li>
              All services provided are subject to availability and may be
              changed without notice.
            </li>
            <li>
              We are not liable for any damages or losses resulting from the use
              of our service center.
            </li>
            <li>
              Any personal data collected will be handled in accordance with our
              privacy policy.
            </li>
            <li>
              By using our service center, you consent to the collection and use
              of your data as described in our privacy policy.
            </li>
            <li>
              We reserve the right to update these terms and conditions at any
              time. Continued use of the service constitutes acceptance of the
              updated terms.
            </li>
          </ul>
          <ul>
            <li>
              By using our service center, you agree to comply with all
              applicable laws and regulations.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account information and password.
            </li>
            <li>
              We reserve the right to modify or terminate our services at any
              time without prior notice.
            </li>
            <li>
              All services provided are subject to availability and may be
              changed without notice.
            </li>
            <li>
              We are not liable for any damages or losses resulting from the use
              of our service center.
            </li>
            <li>
              Any personal data collected will be handled in accordance with our
              privacy policy.
            </li>
            <li>
              By using our service center, you consent to the collection and use
              of your data as described in our privacy policy.
            </li>
            <li>
              We reserve the right to update these terms and conditions at any
              time. Continued use of the service constitutes acceptance of the
              updated terms.
            </li>
          </ul>
          <ul>
            <li>
              By using our service center, you agree to comply with all
              applicable laws and regulations.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account information and password.
            </li>
            <li>
              We reserve the right to modify or terminate our services at any
              time without prior notice.
            </li>
            <li>
              All services provided are subject to availability and may be
              changed without notice.
            </li>
            <li>
              We are not liable for any damages or losses resulting from the use
              of our service center.
            </li>
            <li>
              Any personal data collected will be handled in accordance with our
              privacy policy.
            </li>
            <li>
              By using our service center, you consent to the collection and use
              of your data as described in our privacy policy.
            </li>
            <li>
              We reserve the right to update these terms and conditions at any
              time. Continued use of the service constitutes acceptance of the
              updated terms.
            </li>
          </ul>
          <ul>
            <li>
              By using our service center, you agree to comply with all
              applicable laws and regulations.
            </li>
            <li>
              You are responsible for maintaining the confidentiality of your
              account information and password.
            </li>
            <li>
              We reserve the right to modify or terminate our services at any
              time without prior notice.
            </li>
            <li>
              All services provided are subject to availability and may be
              changed without notice.
            </li>
            <li>
              We are not liable for any damages or losses resulting from the use
              of our service center.
            </li>
            <li>
              Any personal data collected will be handled in accordance with our
              privacy policy.
            </li>
            <li>
              By using our service center, you consent to the collection and use
              of your data as described in our privacy policy.
            </li>
            <li>
              We reserve the right to update these terms and conditions at any
              time. Continued use of the service constitutes acceptance of the
              updated terms.
            </li>
          </ul> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Terms_conditions_modal;
